(function () {
  'use strict';

  [
    'Activity',
    'Region',
  ].forEach(createDirective);

  angular
      .module('tf.retailer.Util')
      .directive('tfcActivityRegionLabel', tfcActivityRegionLabel)
      .controller('ActivityLabelCtrl', ActivityLabelCtrl)
      .controller('RegionLabelCtrl', RegionLabelCtrl)
      .constant('ALL_REGION', 'All Regions');

  function tfcActivityRegionLabel(){
    return {
      restrict: 'E',
      templateUrl : 'Util/ActivityRegionLabel/ActivityRegionLabel.tmpl.html',
      scope: true
    }
  }

  // @ngInject
  function ActivityLabelCtrl(){
    var vm = this;
    vm.selectedLabel = vm.labels.getSelected() && vm.labels.getSelected().getLabel();
    vm.hasMultipleKeys = vm.labels.hasMultipleActivity();
  }

  // @ngInject
  function RegionLabelCtrl(ALL_REGION){
    var vm = this;
    var labelName = vm.labels.getSelectedRegion() &&
        vm.labels.getSelectedRegion().labelDescription ;
    vm.selectedLabel = labelName === 'All' ? ALL_REGION : labelName;
    vm.hasMultipleKeys = vm.labels.hasMultipleRegion();
  }

  function createDirective(type) {
    var name = 'tfc' + type + 'Label';
    angular
        .module('tf.retailer.Util')
        .directive(name, directiveFn);

    // @ngInject
    function directiveFn() {
      return {
        scope : {
          labels : '=',
          pageType : '='
        },
        controller : type + 'LabelCtrl as vm',
        bindToController : true,
        templateUrl : 'Util/ActivityRegionLabel/' + type + '.tmpl.html'
      };
    }
  }

})();